import React from 'react';
import useDocumentStorageService from './useTemplateDocumentStorageService';
import { DocumentStorageContextProvider } from 'framework/documentStorage';

const TemplateDocumentStorageContext = ({ children }: { children: React.ReactNode }) => {
  const actions = useDocumentStorageService();

  return <DocumentStorageContextProvider value={actions}>{children}</DocumentStorageContextProvider>;
};

export default TemplateDocumentStorageContext;
